import Select from "@/common/components/Select";
import { useProductCategories } from "@/common/hooks/queries/useProductCategories";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductCategoryData } from "@/common/types/productCategory.type";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterProductCategoryHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: productCategoriesOptions,
  } = useProductCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ProductCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <Select
      label="Selecione o serviço"
      markAsRequired
      options={productCategoriesOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterProductCategoryHiddenFilter;
